import { Box, Typography, Button, useMediaQuery, useTheme } from '@mui/material';
import LoginHeroImage from '../../assets/login-hero-image.png';
import {
  LOGIN_HERO_TITLE,
  LOGIN_BUTTON_LABEL,
  LOGIN_SECTION_TITLE,
  LOGIN_SECTION_BODY,
  LOGIN_SECTION_LIST_1,
  LOGIN_SECTION_LIST_2,
  LOGIN_SECTION_LIST_3,
  LOGIN_SECTION_LIST_4,
} from '../../constants/messages';
import { useSelector } from 'react-redux';
import { selectLoginRedirectUrl } from '../../redux/slices/uiSettingsSlice';
import { useState } from 'react';
import {apiConfig} from '../../config/api.config';

function LoginPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const loginRedirectUrl = useSelector(selectLoginRedirectUrl) || apiConfig.loginRedirectUrl;
  const [loginDisabled, setLoginDisabled] = useState(false);

  const handleLogin = () => {
    setLoginDisabled(true);
    window.location.assign(loginRedirectUrl);
  };

  return (
    <>
      {/* Hero Image Section with overlayed content */}
      <Box
        sx={{
          width: '100%',
          height: {lg: '40vh', md: '40vh', sm: '50vh', xs: '60vh'},
          minHeight: 200,
          backgroundImage: `url(${LoginHeroImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
          display: 'flex',
          alignItems: 'flex-start',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            height: '100%',
            pl: { xs: 3, sm: 8 },
            zIndex: 1,
          }}
        >
          <Typography
            variant="h3"
            sx={{
              color: '#fff',
              fontWeight: 700,
              textShadow: '0 2px 8px rgba(0,0,0,0.3)',
              mb: 3,
              fontSize: '60px'
            }}
          >
            {LOGIN_HERO_TITLE}
          </Typography>
          <Button
            variant="contained"
            sx={{
              color: (theme) => theme.palette.primary.main,
              size: "large",
              border: '2px',
              borderRadius: '60px',
              backgroundColor: (theme) => theme.palette.brand.inversePrimary,
              cursor: loginDisabled ? 'wait' : 'pointer',
            }}
            onClick={handleLogin}
            disabled={loginDisabled}
          >
            {LOGIN_BUTTON_LABEL}
          </Button>
        </Box>
      </Box>

      {!isMobile &&

        <Box
          sx={{
            width: '100%',
            mt: 6,
            px: { xs: 3, sm: 8 },
            py: 4,
            display: { xs: 'none', sm: 'flex' },
            flexDirection: 'column',
            alignItems: 'flex-start',
            flexGrow: 1,
            minHeight: 0,
          }}
        >
          <Typography variant="h5" sx={{ mb: 2, color: (theme) => theme.palette.brand.inversePrimary }}>
            {LOGIN_SECTION_TITLE}
          </Typography>
          <Typography variant="body1" color="surface.primary" sx={{ mb: 2 }}>
            {LOGIN_SECTION_BODY}
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 0 }}>
            <Typography component="li" variant="body1" color="surface.primary" sx={{ mb: 1 }}>
              {LOGIN_SECTION_LIST_1}
            </Typography>
            <Typography component="li" variant="body1" color="surface.primary" sx={{ mb: 1 }}>
              {LOGIN_SECTION_LIST_2}
            </Typography>
            <Typography component="li" variant="body1" color="surface.primary" sx={{ mb: 1 }}>
              {LOGIN_SECTION_LIST_3}
            </Typography>
            <Typography component="li" variant="body1" color="surface.primary">
              {LOGIN_SECTION_LIST_4}
            </Typography>
          </Box>
        </Box>
      }
    </>
  );
}

export default LoginPage;
